import { API_BASE_URL } from '../constants/api';
import { getAuthToken } from '../utils/auth';

export const authFetch = async (path, options = {}) => {
  const token = getAuthToken();

  if (!token) {
    window.location.href = '/login';
    throw new Error('AUTH_REQUIRED');
  }

  const headers = { ...options.headers };
  headers['Authorization'] = `Bearer ${token}`;

  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers
  });

  if (response.status === 401) {
    localStorage.removeItem('token');
    localStorage.removeItem('artist');
    window.location.href = '/login';
    throw new Error('AUTH_EXPIRED');
  }

  return response;
};

export const previewFetch = (path, options = {}) => {
  return fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: {
      'x-preview-mode': 'true',
      ...(options.headers || {})
    }
  });
};

/* ── Payment Info (plateform MVola / Orange) ── */
const fetchJson = async (path, options = {}) => {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: {
      'x-preview-mode': 'true',
      ...(options.headers || {})
    }
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data?.message || data?.error?.message || 'Erreur réseau');
  }
  return data;
};

export const getPaymentInfo = async () => {
  return fetchJson('/api/albums/payment-info');
};
